import { SET_PARTNERS, SET_PARTNER, SET_PARTNER_PERSONTYPE } from './types';

export default {
    [SET_PARTNERS](state: { partners: any; }, response: any) {
        state.partners = response;
    },

    [SET_PARTNER](state: { partner: any; }, partner: any) {
        state.partner = partner;
    },

    [SET_PARTNER_PERSONTYPE](state: { partner: any; }, personType: any) {
        state.partner.generic.type = personType;
    },
};
